<template>
  <div>
    <CustomerListFilters />

    <v-btn
      v-if="!checkUserRole(['ROLE_SUPPORT'])"
      :disabled="!selectedCustomers.length"
      color="primary"
      elevation="0"
      class="mb-5"
      @click="showAddDefaultContractModal"
    >
      <v-icon class="mr-1" small>mdi-plus</v-icon>
      Aplicar Contrato Padrão
    </v-btn>

    <v-card outlined>
      <v-data-table
        v-model="selectedCustomers"
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        show-select
        :headers="headers"
        :items="customers"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.cpfCnpj`]="{ item }">
          {{ formatDocument(item.cnpj) }}
        </template>
        <template v-slot:[`item.balance`]="{ item }">
          <span
            :class="{
              'green--text text--lighten-1': item.balance > 0,
              'red--text text--lighten-1': item.balance < 0,
            }"
          >
            {{ formatCurrency(item.balance) }}
          </span>
        </template>
        <template v-slot:[`item.use_custom_worker_type`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                small
                :color="item.use_custom_worker_type ? 'primary' : 'grey'"
                v-on="on"
              >
                mdi-card-account-details-outline
              </v-icon>
            </template>
            <span>
              {{ item.use_custom_worker_type ? $t('filters.yes') : $t('filters.no') }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.with_service_provider`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                small
                :color="hasServiceProvider(item) ? 'primary' : 'grey'"
                v-on="on"
              >
                {{ hasServiceProvider(item) ? 'mdi-account-tie-outline' : 'mdi-account-off-outline' }}
              </v-icon>
            </template>
            <span>
              {{ hasServiceProvider(item) ? $t('filters.yes') : $t('filters.no') }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                :class="{ linked: item.asaas_customer_id }"
                :style="`background-image: url(${logoAsaas}`"
                :alt="item.asaas_customer_id ? 'Vinculado' : 'Não vinculado'"
                class="asaas"
                v-on="on"
              />
            </template>
            <span>
              {{
                item.asaas_customer_id
                  ? $t('customer.label.linked')
                  : $t('customer.label.notLinked')
              }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <CustomerActionsMenu
            :item="item"
            @showUpdateCustomerModal="showUpdateCustomerModal"
            @handleAsaasAction="handleAsaasAction"
            @openLinkServiceProviderModal="openLinkServiceProviderModal"
            @showLinkVendorsModal="showLinkVendorsModal"
            @addNewCustomContract="addNewCustomContract"
            @showAddBalanceModal="showAddBalanceModal"
          />
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchCustomers" />

    <ModalLinkAsaasCustomer :customer="customer" />
    <!-- <ModalLinkServiceProviderCustomer :customer="customer" /> -->
    <ModalAddDefaultContract :customers="selectedCustomers" />
    <ModalRemoveLinkAsaasCustomer :customer="customer" />
    <ModalLinkVendors :customer="customer" :key="customer.id" />
    <ModalCustomContract ref="modalCustomContract" />
    <ModalAddBalance ref="modalAddBalance" />

    <CustomerCreateUpdate
      v-if="!checkUserRole(['ROLE_SUPPORT'])"
      ref="createUpdateCustomer"
    />
  </div>
</template>

<script>
// import ModalLinkServiceProviderCustomer from '@/components/customer/modals/ModalLinkServiceProviderCustomer'
import ModalRemoveLinkAsaasCustomer from '@/components/customer/modals/ModalRemoveLinkAsaasCustomer'
import ModalLinkAsaasCustomer from '@/components/customer/modals/ModalLinkAsaasCustomer'
import ModalAddDefaultContract from '@/components/customer/modals/ModalAddDefaultContract'
import ModalCustomContract from '@/components/customer/modals/ModalCustomContract'
import ModalAddBalance from '@/components/customer/modals/ModalAddBalance'
import CustomerListFilters from '@/components/customer/CustomerListFilters'
import CustomerCreateUpdate from '@/components/customer/CustomerCreateUpdate'
import ModalLinkVendors from '@/components/customer/modals/ModalLinkVendors.vue'
import CustomerActionsMenu from '@/components/customer/fragments/CustomerActionsMenu.vue'

import { mapGetters, mapActions } from 'vuex'
import { customersListHeader } from './listHeaders/customersListHeader'
import { checkUserRole } from '@/util/helpers'
import { formatDocument } from '@/util/document'

import logoAsaas from '@/assets/images/logo-asaas.svg'

import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'CustomersList',

  components: {
    // ModalLinkServiceProviderCustomer,
    ModalRemoveLinkAsaasCustomer,
    ModalLinkAsaasCustomer,
    ModalAddDefaultContract,
    ModalCustomContract,
    CustomerListFilters,
    CustomerCreateUpdate,
    ModalLinkVendors,
    ModalAddBalance,
    CustomerActionsMenu,
  },

  data() {
    return {
      formatDocument,
      headers: customersListHeader,
      customer: {},
      logoAsaas,
      selectedCustomers: [],
      selectedCustomerId: null,
      formatCurrency: catalogMonetary,
    }
  },

  computed: {
    ...mapGetters(['customers', 'isLoading', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['openModal', 'fetchCustomer', 'fetchCustomers']),

      hasServiceProvider (item) {
        return Boolean(item.with_service_provider)
      },

    addNewCustomContract(realEstate) {
      this.$refs.modalCustomContract.openCreateModal(realEstate)
    },

    showLinkAsaasCustomerModal(customerDocument, customerName, customerId) {
      this.customer = { customerDocument, customerName, customerId }
      this.openModal('LINK_ASAAS_CUSTOMER_MODAL')
    },

    openLinkServiceProviderModal(item) {
      this.customer = item
      this.openModal('LINK_SERVICE_PROVIDER_CUSTOMER')
    },

    showRemoveLinkAsaasCustomerModal(
      customerDocument,
      customerName,
      customerId,
      customerAsaasId
    ) {
      this.customer = {
        customerDocument,
        customerName,
        customerId,
        customerAsaasId,
      }
      this.openModal('REMOVE_LINK_ASAAS_CUSTOMER_MODAL')
    },

    showAddDefaultContractModal() {
      this.openModal('ADD_DEFAULT_CONTRACT_MODAL')
    },

    handleAsaasAction(item) {
      if (!item.asaas_customer_id) {
        this.showLinkAsaasCustomerModal(
          this.formatDocument(item.cnpj),
          item.name,
          item.id
        )
      } else {
        this.showRemoveLinkAsaasCustomerModal(
          this.formatDocument(item.cnpj),
          item.name,
          item.id,
          item.asaas_customer_id
        )
      }
    },

    showLinkVendorsModal(customerId, vendors) {
      this.customer = { customerId, vendors }
      this.openModal('CUSTOMER_LINK_VENDORS_MODAL')
    },

    showAddBalanceModal(id) {
      this.fetchCustomer(id)
      this.$refs.modalAddBalance.resetForm()
      this.openModal('ADD_BALANCE_MODAL')
    },

    showUpdateCustomerModal(data) {
      this.$refs.createUpdateCustomer.openUpdateModal(data.id)
    },

    openCreateCustomerModal() {
      const modal = this.$refs.createUpdateCustomer?.$refs.createModal
      modal.openCreateModal()
    },

    checkUserRole,
  },

  mounted() {
    this.fetchCustomers()
  },
}
</script>

<style scoped>
.asaas {
  display: block;
  width: 22px;
  height: 22px;
  margin: 0 auto;
  border-radius: 50%;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center 2px;
  background-color: #fff;
  box-shadow: 0 0 0 5px #fff;
}

.asaas.linked {
  background-position: center -32px;
}
</style>
